import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../alert-component';
import { DatepickerComponent } from './datepicker-component'
import { DropdownComponent } from './dropdown-component';
import { FoodLogsComponent } from './food-logs/food-logs.component';
import { FoodResultsComponent } from './food-results/food-results.component';

import {MatNativeDateModule} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DemoMaterialModule} from './materials-module';
import { WeightlogComponent } from './weightlog/weightlog.component';
import { ActivitylogComponent } from './activitylog/activitylog.component';
import { HealthlogComponent } from './healthlog/healthlog.component';
import { ActivityplanComponent } from './activityplan/activityplan.component';
import { FoodplanComponent } from './foodplan/foodplan.component';
import { CoachviewComponent } from './coachview/coachview.component';


@NgModule({
  declarations: [NgbdModalContent, DatepickerComponent, DropdownComponent, FoodResultsComponent, FoodLogsComponent, WeightlogComponent, ActivitylogComponent, HealthlogComponent, ActivityplanComponent, FoodplanComponent, CoachviewComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    DemoMaterialModule,
  ],
  entryComponents: [DatepickerComponent, DropdownComponent],
  bootstrap: [DatepickerComponent, DropdownComponent],
  exports: [
    FoodLogsComponent,
    WeightlogComponent,
    ActivitylogComponent,
    HealthlogComponent,
    FoodResultsComponent,
    FoodplanComponent,
    ActivityplanComponent,
  ]

})
export class LogsModule { }
